import cn from 'classnames';
import type { FC } from 'react';

import styles from './TreatmentStatusChip.module.scss';

interface TreatmentStatusChipProps {
  archived: boolean;
  testId?: string;
}

/**
 * Table cell chip showing whether a treatment type is active or archived.
 */
const TreatmentStatusChip: FC<TreatmentStatusChipProps> = ({ archived, testId = 'treatment-status-chip' }) => (
  <span
    className={cn(styles.chip, archived ? styles.archived : styles.active)}
    data-testid={testId}
    data-status={archived ? 'archived' : 'active'}
  >
    {archived ? 'archived' : 'active'}
  </span>
);

export default TreatmentStatusChip;
